import { addDays, addHours, format } from 'date-fns';

export const addDaysToDate = (startDate: Date, daysToAdd: number, excludeWeekend: boolean) => {
  if (excludeWeekend) {
    const currentDayOfWeek = startDate.getDay();
    if (currentDayOfWeek === 4 || currentDayOfWeek === 5) daysToAdd += 2;
    else if (currentDayOfWeek === 6) daysToAdd += 1;
  }
  return addHours(addDays(startDate, daysToAdd), 1);
};

export const getFormatedDate = (date: Date): any => {
  // the below line should be used when the date is being stored in DB is the UTC date
  return format(new Date(date), 'dd-MMMMMM-yyyy - hh:mmaa');
};

export const getNumericFormatedDate = (date: Date): any => {
  return format(new Date(date), 'dd/MM/yy - hh:mmaa');
};
export const getCustomFormatedDate = (date: Date, dateFormat: string): any => {
  return format(new Date(date), dateFormat);
};
